import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';


import { MaterialModule } from '../material.module';
import { TourGuideComponent } from './tour-guide/tour-guide.component';
import { LoadingComponent } from './loading/loading.component';
import { MatProgressSpinnerModule } from '@angular/material';
import { LoadingToastComponent } from './loading-toast/loading-toast.component';
import { WelcomeToastComponent } from './welcome-toast/welcome-toast.component';

import { BottomsheetComponent } from './bottomsheet/bottomsheet.component';
import { LoadingLibrosComponent } from './loading-libros/loading-libros.component';
import { ModalInformationComponent } from './modal-information/modal-information.component';
import { ModalGlobalComponent } from './modal-global/modal-global.component';
import { PaginacionComponent } from './paginacion/paginacion.component';
import { BuscadorComponent } from './buscador/buscador.component';
import { LoadingAdmisionesComponent } from './loading-admisiones/loading-admisiones.component';
import { EncabezadoComponent } from './encabezado/encabezado.component';
import { FormsModule } from '@angular/forms';
import { ToggleOpcionesComponent } from './toggle-opciones/toggle-opciones.component';


@NgModule({
  declarations: [
    LoadingComponent,
    TourGuideComponent,
    BottomsheetComponent,
    LoadingToastComponent,
    WelcomeToastComponent,
    LoadingLibrosComponent,
    ModalInformationComponent,
    ModalGlobalComponent,
    PaginacionComponent,
    BuscadorComponent,
    LoadingAdmisionesComponent,
    EncabezadoComponent,
    ToggleOpcionesComponent,
  ],
  imports: [
    RouterModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    CommonModule,
    MaterialModule,
    FormsModule
  ],
  exports: [
    LoadingLibrosComponent,
    LoadingComponent,
    TourGuideComponent,
    ModalGlobalComponent,
    LoadingAdmisionesComponent,
    EncabezadoComponent,
    PaginacionComponent,
    BuscadorComponent,
    ToggleOpcionesComponent,
   ],
})
export class SharedModule { }
